import React from 'react'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever'
import { connect } from 'react-redux'
import { desinformarStopQ } from '../../../actions'

function OperacionesCodigosDeCupo (props) {
  const { data, desinformarStopQ } = props

  function onClick () {
    const result = window.confirm(`¿Desea desinformar de STOP el código de cupo ${(data.codigoCupo).trim()} y liberar su nominación?`)
    if (result) {
      desinformarStopQ(data)
    }
  }

  const desinformar = (data && data.stopq === 'Informado' && data.tipoCupo === 'N' && (data.estado === 'Sin consumir' || data.estado === 'Rechazado'))

  return (
    <Tooltip title={'Desinformar de STOP y desnominar'}>
      <span>
        <IconButton onClick={() => onClick()}
          disabled={!desinformar}>
          <DeleteForeverIcon
            fontSize='default'
            color={(desinformar) ? 'secondary' : 'disabled'}
          />
        </IconButton>
      </span>
    </Tooltip>
  )
}

const mapActionsToProps = {
  desinformarStopQ
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux((OperacionesCodigosDeCupo))
